import { CartographyInfosResourcePosition } from './cartography-infos-resource-position';

export class CartographyResourceInfosPositionMat extends CartographyInfosResourcePosition {}
